import React from "react";
import { TaskPriority } from "../../../__generated__/globalTypes";

interface IProps {
  priority: TaskPriority;
}

const STYLES: Record<TaskPriority, string> = {
  [TaskPriority.Low]: "bg-gray-100 text-gray-600",
  [TaskPriority.Medium]: "bg-amber-100 text-amber-700",
  [TaskPriority.High]: "bg-red-100 text-red-700",
};

const LABELS: Record<TaskPriority, string> = {
  [TaskPriority.Low]: "Basse",
  [TaskPriority.Medium]: "Moyenne",
  [TaskPriority.High]: "Haute",
};

export const TaskPriorityBadge: React.FC<IProps> = ({ priority }) => (
  <span
    className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${STYLES[priority]}`}
  >
    {LABELS[priority]}
  </span>
);
